$(function () {
    var $input = $('.search-input');

    if (!$input.length) return;

    var textIndex = 0;
    var charIndex = 0;
    var isDeleting = false;

    var typingSpeed = 90;
    var deletingSpeed = 45;
    var pauseAfterTyping = 1500;
    var pauseAfterDeleting = 300;

    function animatePlaceholder() {
        var currentText = searchTexts[textIndex];

        if (isDeleting) {
            charIndex--;
        } else {
            charIndex++;
        }

        $input.attr('placeholder', currentText.substring(0, charIndex));

        if (!isDeleting && charIndex === currentText.length) {
            setTimeout(function () {
                isDeleting = true;
                animatePlaceholder();
            }, pauseAfterTyping);
            return;
        }

        if (isDeleting && charIndex === 0) {
            isDeleting = false;
            textIndex++;

            if (textIndex >= searchTexts.length) {
                textIndex = 0;
            }

            setTimeout(animatePlaceholder, pauseAfterDeleting);
            return;
        }

        setTimeout(
            animatePlaceholder,
            isDeleting ? deletingSpeed : typingSpeed
        );
    }

    animatePlaceholder();
});